









import Vue from 'vue'
import AgentDestinationForm, {
  Destination,
} from '@/components/molecules/AgentDestination/PartnerAgentDestinationForm.vue'
import { AgentSalesDestination, Mutation } from '@/types/generated/graphql'
import QUERY_FETCH from '@/graphql/partner/agentSalesDestination.gql'
import MUTATION_UPDATE from '@/graphql/partner/updateAgentSalesDestination.gql'

type Data = {
  partnerId: string
  id: string
  destination: AgentSalesDestination | null
}

type Methods = {
  onClickSave: (destination: Destination) => void
  onClickBack: () => void
}

type Computed = {
  editedDestination: Destination | null
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: 'PartnerAgentDestinationEdit',
  components: {
    AgentDestinationForm,
  },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
      id: this.$route.params.id,
      destination: null,
    }
  },
  computed: {
    editedDestination() {
      if (this.destination == null) {
        return null
      }
      return {
        partnerId: this.$route.params.partnerId as string,
        storeId: this.destination.storeId as string,
        firstName: this.destination.name.first as string,
        lastName: this.destination.name.last as string,
        firstNameKana: this.destination.nameKana.first as string,
        lastNameKana: this.destination.nameKana.last as string,
        zipCode: this.destination.address.zipCode.fullCode as string,
        prefId: this.destination.address.pref.id as string,
        address1: this.destination.address.address1 as string,
        address2: this.destination.address.address2 as string,
        phone: this.destination.phone as string,
        email: this.destination.email as string,
      }
    },
  },
  methods: {
    async onClickSave(destination: Destination) {
      if (this.destination == null) {
        return
      }
      const agentSalesDestinationId = this.destination.agentSalesDestinationId
      await this.$apollo.mutate<Mutation>({
        mutation: MUTATION_UPDATE,
        variables: {
          input: { agentSalesDestinationId, ...destination },
        },
      })
      await this.$router.push({
        name: 'PartnerAgentDestinationList',
        params: { partnerId: this.partnerId },
      })
    },
    onClickBack() {
      this.$router.back()
    },
  },
  apollo: {
    fetch: {
      query: QUERY_FETCH,
      variables() {
        return {
          partnerId: this.partnerId,
          id: this.id,
        }
      },
      fetchPolicy: 'network-only',
      update({ agentSalesDestination }) {
        this.destination = agentSalesDestination
      },
    },
  },
})
